import React, { useState, useEffect } from "react";
import { withRouter } from "react-router-dom";
import { store } from "react-notifications-component";
import api from "../../services/api";
import GenericUpper from "../../components/generic-upper";
import Input from "../../components/input/input_v2";
import Button from "../../components/button/button_v2";
import Select from "../../components/select/select_v2";
import estados from "../../services/estados";
import { Container } from "react-grid-system";
import Table from "../../components/table";
import TBody from "../../components/tbody";
import { ProdutoresAddContainer, YesNoContainer } from "./styles";
import ModalYesNo from "../../components/modal/modalYesNo";
import ModalText from "../../components/modal/modalText";
import Modal from '../../components/modal/modalGeneric';
import CardGeral from "../../components/card-geral/index";
import validadorCpfCnpj from "../../services/validadorCpfCnpj";
import validadorDeEmail from "../../services/validadorEmail";
import buscaCep from "../../services/buscaCep";
import Interruptor from "../../components/interruptor";
import { isTotvs, isOmie } from "../../services/globalFunctions";

import identifyErrorMenssage from "../../services/identifyErrorMenssage";
const EditProdutores = ({ ...props }) => {

    const [nome, setNome] = useState('');
    const [cpf_cnpj, setCpfCnpj] = useState('');
    const [telefone, setTelefone] = useState('');
    const [celular, setCelular] = useState('');
    const [cep, setCep] = useState('');
    const [logradouro, setLogradouro] = useState('');
    const [numero, setNumero] = useState('');
    const [complemento, setComplemento] = useState('');
    const [bairro, setBairro] = useState('');
    const [cidade, setCidade] = useState('');
    const [estado, setEstado] = useState('');
    const [estadoCep, setEstadoCep] = useState('');
    const [id, setId] = useState('');
    const [msg, setMsg] = useState('');
    const [msg2, setMsg2] = useState('');
    const [showModal, setShowModal] = useState(false);
    const [showModalYesNo, setShowModalYesNo] = useState(false);
    const [locais, setLocais] = useState([]);
    const [agendas, setAgendas] = useState([]);
    const [enviadoCrea, setEnviadoCrea] = useState(false);
    const [respostaCrea, setRespostaCrea] = useState('');
    const [respostaArt, setRespostaArt] = useState('');
    const [showModalText, setShowModalText] = useState(false);
    const [nomeInicial, setNomeInicial] = useState('');
    const [cpfInicial, setCpfInicial] = useState('');
    const [size_screen, setSizeScreen] = useState(window.screen.width);
    const [telefoneInicial, setTelefoneInicial] = useState('');
    const [cepInicial, setCepInicial] = useState('');
    const [logradouroInicial, setLogradouroInicial] = useState('');
    const [numeroInicial, setNumeroInicial] = useState('');
    const [bairroInicial, setBairroInicial] = useState('');
    const [cidadeInicial, setCidadeInicial] = useState('');
    const lockFilledFields = !!props.lockFilledFields;
    const [loading, setLoading] = useState(false);
    const [erroCpf, setErroCpf] = useState(false);
    const [erroCpfMsg, setErroCpfMsg] = useState('');
    const [erroNome, setErroNome] = useState(false);
    const [erroNomeMsg, setErroNomeMsg] = useState('');
    const [erroTelefone, setErroTelefone] = useState(false);
    const [erroTelefoneMsg, setErroTelefoneMsg] = useState('');
    const [erroCep, setErroCep] = useState(false);
    const [erroCepMsg, setErroCepMsg] = useState('');
    const [erroLogradouro, setErroLogradouro] = useState(false);
    const [erroLogradouroMsg, setErroLogradouroMsg] = useState('');
    const [erroBairro, setErroBairro] = useState(false);
    const [erroBairroMsg, setErroBairroMsg] = useState('');
    const [erroNumero, setErroNumero] = useState(false);
    const [erroNumeroMsg, setErroNumeroMsg] = useState('');
    const [erroCidade, setErroCidade] = useState(false);
    const [erroCidadeMsg, setErroCidadeMsg] = useState('');
    const [erroEstado, setErroEstado] = useState(false);
    const [erroEstadoMsg, setErroEstadoMsg] = useState('');
    const [resolveConflict, setResolveConflict] = useState([]);
    const [btnCancelar, setBtnCancelar] = useState(false);
    const [modalGeneric, setModalGeneric] = useState(<></>);
    const [showModalGeneric, setShowModalGeneric] = useState(false);
    const [responseConflict, setResponseConflict] = useState([]);
    const [email, setEmail] = useState('');
    const [loaded, setLoaded] = useState(false);
    const [erroEmail, setErroEmail] = useState(false);
    const [erroEmailMsg, setErroEmailMsg] = useState('');

    const [status, setStatus] = useState(1)


    const validateCpf = (cpfCnpj) => {
        setCpfCnpj(cpfCnpj);
        setErroCpf(false);
    }

    const validateEmailChange = (value) => {
        setEmail(value);
        if (erroEmail) {
            setErroEmail(false);
            setErroEmailMsg('');
        }
    }

    const emailIsValid = (value) => {
        if (value && !validadorDeEmail(value)) {
            setErroEmail(true);
            setErroEmailMsg('Insira um e-mail válido.');
            return false;
        }
        setErroEmail(false);
        setErroEmailMsg('');
        return true;
    }

    const cpfIsValid = async (value) => {
        if (!value) {
            setErroCpf(true);
            setErroCpfMsg('Informe um CPF/CNPJ.');

            store.addNotification({
                title: "Erro!",
                message: "Informe um CPF/CNPJ.",
                type: "danger",
                insert: "top",
                container: "top-right",
                animationIn: ["animated", "fadeIn"],
                animationOut: ["animated", "fadeOut"],
                dismiss: {
                    duration: 4000,
                    onScreen: true
                }
            });
            return;
        }

        const resultado = await validadorCpfCnpj(value);

        setErroCpf(!resultado.valido);
        setErroCpfMsg(resultado.erro || 'Informe um CPF/CNPJ válido!');

        if (!resultado.valido) {
            store.addNotification({
                title: "Erro!",
                message: resultado.erro || "CPF/CNPJ inserido é inválido.",
                type: "danger",
                insert: "top",
                container: "top-right",
                animationIn: ["animated", "fadeIn"],
                animationOut: ["animated", "fadeOut"],
                dismiss: {
                    duration: 4000,
                    onScreen: true
                }
            });
        }
    }

    const fetchCep = async (c) => {
        try {
            const responseCep = await buscaCep(cep);

            const { logradouro, bairro, localidade, uf } = responseCep;

            setLogradouro(logradouro);
            setBairro(bairro);
            setCidade(localidade);
            setEstado(uf);
            setEstadoCep(uf);

        } catch (err) {

            store.addNotification({
                title: "Erro!",
                message: identifyErrorMenssage(err),
                type: "danger",
                insert: "top",
                container: "top-right",
                animationIn: ["animated", "fadeIn"],
                animationOut: ["animated", "fadeOut"],
                dismiss: {
                    duration: 4000,
                    onScreen: true
                }
            });
        }
    };

    const limpaCep = async e => {
        if ((estadoCep) != estado) {
            if ((cep != "") || (logradouro != "") || (bairro != "") || (cidade != "")) {

                setLogradouro('');
                setBairro('');
                setCidade('');
                setEstado('');
                setCep('');
                setNumero('');


                let input = document.querySelector("#cep");
                let select = document.querySelector("#estado");
                input.classList.add("error");
                select.classList.add("error");

                store.addNotification({
                    title: "Erro!",
                    message: "Este estado não pertence ao CEP informado!",
                    type: "danger",
                    insert: "top",
                    container: "top-right",
                    animationIn: ["animated", "fadeIn"],
                    animationOut: ["animated", "fadeOut"],
                    dismiss: {
                        duration: 4000,
                        onScreen: true
                    }
                });
            }
        } else {

            try {
                let select = document.querySelector("#estado");
                select.classList.remove("error");
            } catch (e) {

            }
        }
    };

    const goBack = () => {
        props.history.goBack();
    }

    const editPost = async e => {
        setLoading(true);

        if (erroCpf === true || !emailIsValid(email)) {
            store.addNotification({
                title: "Erro!",
                message: `Verifique os campos em vermelho!`,
                type: "danger",
                insert: "top",
                container: "top-right",
                animationIn: ["animated", "fadeIn"],
                animationOut: ["animated", "fadeOut"],
                dismiss: {
                    duration: 4000,
                    onScreen: true
                }
            });
            setLoading(false);

        } else {

            const payload = {
                nome,
                cpf_cnpj,
                telefone,
                celular,
                cep,
                logradouro,
                numero,
                bairro,
                complemento,
                cidade,
                estado,
                email,
                // Envia a receita por e-mail sempre que o produtor tiver um e-mail válido cadastrado.
                enviar_receita: validadorDeEmail(email) ? 1 : 0,
                status
            };
            try {
                const response = await api.put(`/produtores/${id}`, payload);

                if (response.status === 200) {
                    setLoading(false);

                    // props.history.push(`/produtores/${id}`);

                    store.addNotification({
                        title: "Sucesso!",
                        message: "O produtor foi editado corretamente.",
                        type: "success",
                        insert: "top",
                        container: "top-right",
                        animationIn: ["animated", "fadeIn"],
                        animationOut: ["animated", "fadeOut"],
                        dismiss: {
                            duration: 5000,
                            onScreen: true
                        }
                    });

                    if (props.isModal) {
                        props.update?.();
                        props.openModal?.(false);
                    }
                }
            } catch (err) {
                setLoading(false);

                if (err.response.status === 409) {
                    const arts = err.response.data.data.arts;
                    const contracts = err.response.data.data.contratos;
                    const payloadProducer = err.response.data.data.payload_producer;

                    resolveProducerConflict(arts, contracts, payloadProducer);
                } else {
                    try {
                        // Reset todos os erros
                        setErroNome(false);
                        setErroCpf(false);
                        setErroTelefone(false);
                        setErroCep(false);
                        setErroLogradouro(false);
                        setErroBairro(false);
                        setErroNumero(false);
                        setErroCidade(false);
                        setErroEstado(false);

                        setErroNomeMsg('');
                        setErroCpfMsg('');
                        setErroTelefoneMsg('');
                        setErroCepMsg('');
                        setErroLogradouroMsg('');
                        setErroBairroMsg('');
                        setErroNumeroMsg('');
                        setErroCidadeMsg('');
                        setErroEstadoMsg('');

                        // Verifica se existe o novo formato de erro (baseado no exemplo fornecido)
                        if (err.response?.data?.data?.message && Array.isArray(err.response.data.data.message)) {
                            const errorMessages = err.response.data.data.message;

                            errorMessages.forEach(message => {
                                if (message.includes('nome should not be empty')) {
                                    setErroNome(true);
                                    setErroNomeMsg('O campo não pode estar vazio');
                                } else if (message.includes('cpf_cnpj should not be empty')) {
                                    setErroCpf(true);
                                    setErroCpfMsg('O campo não pode estar vazio');
                                } else if (message.includes('telefone should not be empty')) {
                                    setErroTelefone(true);
                                    setErroTelefoneMsg('O campo não pode estar vazio');
                                } else if (message.includes('cep should not be empty')) {
                                    setErroCep(true);
                                    setErroCepMsg('O campo não pode estar vazio');
                                } else if (message.includes('logradouro should not be empty')) {
                                    setErroLogradouro(true);
                                    setErroLogradouroMsg('O campo não pode estar vazio');
                                } else if (message.includes('bairro should not be empty')) {
                                    setErroBairro(true);
                                    setErroBairroMsg('O campo não pode estar vazio');
                                } else if (message.includes('numero should not be empty')) {
                                    setErroNumero(true);
                                    setErroNumeroMsg('O campo não pode estar vazio');
                                } else if (message.includes('cidade should not be empty')) {
                                    setErroCidade(true);
                                    setErroCidadeMsg('O campo não pode estar vazio');
                                } else if (message.includes('estado should not be empty')) {
                                    setErroEstado(true);
                                    setErroEstadoMsg('O campo não pode estar vazio');
                                }
                            });
                        }
                        // Verifica se o formato é direto em data.message (sem data.data)
                        else if (err.response?.data?.message && Array.isArray(err.response.data.message)) {
                            const errorMessages = err.response.data.message;

                            errorMessages.forEach(message => {
                                if (message.includes('nome should not be empty')) {
                                    setErroNome(true);
                                    setErroNomeMsg('O campo não pode estar vazio');
                                } else if (message.includes('cpf_cnpj should not be empty')) {
                                    setErroCpf(true);
                                    setErroCpfMsg('O campo não pode estar vazio');
                                } else if (message.includes('telefone should not be empty')) {
                                    setErroTelefone(true);
                                    setErroTelefoneMsg('O campo não pode estar vazio');
                                } else if (message.includes('cep should not be empty')) {
                                    setErroCep(true);
                                    setErroCepMsg('O campo não pode estar vazio');
                                } else if (message.includes('logradouro should not be empty')) {
                                    setErroLogradouro(true);
                                    setErroLogradouroMsg('O campo não pode estar vazio');
                                } else if (message.includes('bairro should not be empty')) {
                                    setErroBairro(true);
                                    setErroBairroMsg('O campo não pode estar vazio');
                                } else if (message.includes('numero should not be empty')) {
                                    setErroNumero(true);
                                    setErroNumeroMsg('O campo não pode estar vazio');
                                } else if (message.includes('cidade should not be empty')) {
                                    setErroCidade(true);
                                    setErroCidadeMsg('O campo não pode estar vazio');
                                } else if (message.includes('estado should not be empty')) {
                                    setErroEstado(true);
                                    setErroEstadoMsg('O campo não pode estar vazio');
                                }
                            });
                        }
                        // Fallback para o formato antigo
                        else if (err.response?.data?.errors) {
                            const errors = err.response.data.errors;

                            for (let field in errors) {
                                if (field === 'nome') {
                                    setErroNome(true);
                                    setErroNomeMsg('O campo não pode estar vazio');
                                } else if (field === 'cpf_cnpj') {
                                    setErroCpf(true);
                                    if (cpf_cnpj === '') {
                                        setErroCpfMsg('O campo não pode estar vazio');
                                    } else {
                                        setErroCpfMsg('Informe um CPF/CNPJ válido!');
                                    }
                                } else if (field === 'telefone') {
                                    setErroTelefone(true);
                                    setErroTelefoneMsg('O campo não pode estar vazio');
                                } else if (field === 'cep') {
                                    setErroCep(true);
                                    setErroCepMsg('O campo não pode estar vazio');
                                } else if (field === 'logradouro') {
                                    setErroLogradouro(true);
                                    setErroLogradouroMsg('O campo não pode estar vazio');
                                } else if (field === 'bairro') {
                                    setErroBairro(true);
                                    setErroBairroMsg('O campo não pode estar vazio');
                                } else if (field === 'numero') {
                                    setErroNumero(true);
                                    setErroNumeroMsg('O campo não pode estar vazio');
                                } else if (field === 'cidade') {
                                    setErroCidade(true);
                                    setErroCidadeMsg('O campo não pode estar vazio');
                                } else if (field === 'estado') {
                                    setErroEstado(true);
                                    setErroEstadoMsg('O campo não pode estar vazio');
                                }
                            }
                        }

                        store.addNotification({
                            title: "Erro de validação",
                            message: "Verifique os campos em vermelho",
                            type: "danger",
                            insert: "top",
                            container: "top-right",
                            animationIn: ["animate__animated", "animate__fadeIn"],
                            animationOut: ["animate__animated", "animate__fadeOut"],
                            dismiss: {
                                duration: 5000,
                                onScreen: true
                            }
                        });
                    } catch (validationError) {
                        console.error('Erro ao processar validação:', validationError);
                        store.addNotification({
                            title: "Erro!",
                            message: identifyErrorMenssage(validationError),
                            type: "danger",
                            insert: "top",
                            container: "top-right",
                            animationIn: ["animate__animated", "animate__fadeIn"],
                            animationOut: ["animate__animated", "animate__fadeOut"],
                            dismiss: {
                                duration: 5000,
                                onScreen: true
                            }
                        });
                    }
                }
            }
        }
    };

    const resolveProducerConflict = (arts, contracts, payloadProducer) => {

        setResolveConflict({
            arts,
            contracts,
            payloadProducer
        });

        // Pré-preenche a decisão do usuário com defaults
        const defaults = arts.map((art) => ({
            enviado_crea: art.exist_prescription === true ? true : false,
            agro_crea_id: art.agro_crea_id,
            numero_art: art.numero_art,
            exist_prescription: art.exist_prescription === true ? true : false,
        }));
        setResponseConflict(defaults);

        setModalGeneric(
            <div style={{
                width: '100%',
                padding: '10px',
            }}>
                <h2>Atenção</h2>
                <p>Este produtor está vinculado em {contracts.length} {contracts.length > 1 ? `contratos ativos` : `contrato ativo`}.</p>
                <p>Confirme se os dados já foram enviados ao CREA para continuar com a edição do produtor.</p>
                <table style={{
                    width: '100%',
                    height: 'auto',
                    margin: 'auto',
                    marginBottom: '20px'
                }}>
                    <tr>
                        <th style={{ border: '1px solid #000', padding: '5px' }}>ART</th>
                        <th style={{ border: '1px solid #000', padding: '5px' }}>Existem receitas emitidas?</th>
                        <th style={{ border: '1px solid #000', padding: '5px' }}>CREA</th>
                    </tr>
                    {arts.map((art, i) => (
                        <tr>
                            <td style={{ border: '1px solid #000', padding: '5px' }}>{art.numero_art}</td>
                            <td style={{ border: '1px solid #000', padding: '5px' }}>{art.exist_prescription === true ? 'SIM' : 'NÃO'}</td>
                            <td style={{ border: '1px solid #000', padding: '5px' }}> <YesNoContainer disabled={false} loading={false}> <span>Dados enviados ao CREA?</span> <Interruptor disabled={art.exist_prescription} value={art.exist_prescription === true ? true : responseConflict[i] ? responseConflict[i].enviado_crea : false} onChange={(e) => saveProducerConflict(e, art.numero_art, art.exist_prescription, art.agro_crea_id, i)} /> </YesNoContainer></td>
                        </tr>
                    ))}
                </table>

                <p style={{ width: '100%', fontSize: '75%' }}><span style={{ color: '#F10' }}>*</span>Para as ARTs com os dados <u>já enviados ao CREA</u> é exigido uma nova ART, nesse caso estaremos <b>inativando</b> o contrato na ART vigente.</p>
                <p style={{ width: '100%', fontSize: '75%' }}><span style={{ color: '#F10' }}>*</span>Para as ARTs com os dados <u>não enviados ao CREA</u>, estaremos <b>alterando</b> os dados sob sua responsabilidade, mantendo o produtor como <b>ativo</b> na ART vigente.</p>
                <p style={{ width: '100%', fontSize: '75%' }}><span style={{ color: '#F10' }}>*</span>Para as ARTs que possuem receitas emitidas vamos considerar que os dados <b><u>já foram enviados ao CREA</u></b>.</p>

                <div
                    className="button-finish"
                    style={{
                        width: '100%',
                        display: 'flex',
                        flexDirection: 'row',
                        justifyContent: 'center',
                        alignItems: 'center',
                        marginTop: '20px',
                        marginBottom: '20px',
                    }}
                >
                    <Button
                        width='255px'
                        height='50px'
                        value='CONFIRMAR'
                        outline={false}
                        disabled={false}
                        onClick={() => confirmProducerConflict(payloadProducer)}
                        loading={false}
                    />
                </div>
            </div>
        );

        setShowModalGeneric(true);
    }

    const saveProducerConflict = (enviado, numArt, existPrescription, agroCreaId, index) => {
        let resolve = responseConflict;

        resolve[index] = {
            enviado_crea: existPrescription === true ? true : enviado,
            agro_crea_id: agroCreaId,
            numero_art: numArt,
            exist_prescription: existPrescription === true ? true : false,
        };

        setResponseConflict(resolve);
    }

    const confirmProducerConflict = async (payloadProducer) => {
        setModalGeneric(<></>);
        setShowModalGeneric(false);
        setLoading(true);

        // Fallback: se não mexeu no toggle, usa os defaults
        const artsPayload = (responseConflict && responseConflict.length > 0)
            ? responseConflict
            : (resolveConflict.arts || []).map((art) => ({
                enviado_crea: art.exist_prescription === true ? true : false,
                agro_crea_id: art.agro_crea_id,
                numero_art: art.numero_art,
                exist_prescription: art.exist_prescription === true ? true : false,
            }));

        const payload = {
            arts: artsPayload,
            payload_producer: payloadProducer
        }

        try {
            const response = await api.put(`/produtores/${id}/confirmar`, payload);

            if (response) {
                setLoading(false);

                props.history.push(`/produtores/${id}`);

                store.addNotification({
                    title: "Sucesso!",
                    message: "O produtor foi editado corretamente.",
                    type: "success",
                    insert: "top",
                    container: "top-right",
                    animationIn: ["animated", "fadeIn"],
                    animationOut: ["animated", "fadeOut"],
                    dismiss: {
                        duration: 5000,
                        onScreen: true
                    }
                });
            }
        } catch (error) {
            store.addNotification({
                title: "Erro!",
                message: identifyErrorMenssage(error),
                type: "danger",
                insert: "top",
                container: "top-right",
                animationIn: ["animated", "fadeIn"],
                animationOut: ["animated", "fadeOut"],
                dismiss: {
                    duration: 5000,
                    onScreen: true
                }
            });
            setLoading(false);
        }
    }

    const addLocal = () => {
        props.history.push(`/localdeaplicacao/add/${props.match.params.id}`)
    }

    const modalClose = e => {
        if (showModal == true) {
            setShowModal(false);
        }
        if (showModalYesNo == true) {
            setShowModalYesNo(false);
        }
    }

    const updateRespostaYesNo = async (resposta) => {
        setShowModalYesNo(false);
    }

    const closeOk = e => {
        setShowModalText(false);
    }

    const updateOk = async (resposta) => {
        setShowModalText(false);
    }

    const resolveProdutorId = () => props.idProdutor || props.match?.params?.id;

    const getProdutores = async () => {
        try {
            const id = resolveProdutorId();
            setId(id);

            const response = await api.get(`/produtores/${id}`);
            const produtores = response.data.data;

            setNome(produtores.nome);
            setCpfCnpj(produtores.cpf_cnpj);
            setTelefone(produtores.telefone);
            setCelular(produtores.celular);
            setCep(produtores.cep);
            setLogradouro(produtores.logradouro);
            setNumero(produtores.numero);
            setComplemento(produtores.complemento);
            setCidade(produtores.cidade);
            setBairro(produtores.bairro);
            setEstadoCep(produtores.estado);
            setEstado(produtores.estado);
            setNomeInicial(produtores.nome);
            setCpfInicial(produtores.cpf_cnpj);
            setTelefoneInicial(produtores.telefone);
            setCepInicial(produtores.cep);
            setLogradouroInicial(produtores.logradouro);
            setNumeroInicial(produtores.numero);
            setBairroInicial(produtores.bairro);
            setCidadeInicial(produtores.cidade);
            setEmail(produtores.email);
            setStatus(produtores.status);
            setLoaded(true);

        } catch (error) {
        }
    };

    const getLocais = async () => {
        const id = resolveProdutorId();
        setId(id);

        try {

            let l = [];

            api.get(`/produtores/${id}/fazendas`).then(response => {
                let locais = response.data.data;

                setLocais(locais);

            });

        } catch (error) {
        }
    }

    const getAgendas = async () => {
        try {
            const id = resolveProdutorId();
            setId(id);

            const response = await api.get(`/agenda/produtor/${id}`);
            const agendas = response.data.data;

            setAgendas(agendas);
        } catch (error) {
        }
    }

    useEffect(() => {
        window.scrollTo(0, 0);
        getProdutores();
        getLocais();
        getAgendas();
    }, []);

    useEffect(() => {
        setSizeScreen(window.screen.width);
    }, [window.screen.width])

    const produtorInativo = Number(status) === 0;

    return (
        <>
            <GenericUpper
                title="Edição de Produtores"
                subtitle="Edite este Produtor"
            ></GenericUpper>

            <ProdutoresAddContainer isPage={true}>
                <Container>
                    <form>
                        <Input
                            name="nome"
                            label="Nome"
                            labelWithAsterisk={true}
                            type="text"
                            id="nome"
                            value={nome}
                            onChange={e => {
                                setNome(e);
                                if (erroNome) {
                                    setErroNome(false);
                                    setErroNomeMsg('');
                                }
                            }}
                            maxlength={50}
                            erro={erroNome}
                            messageErro={erroNomeMsg}
                            disabled={(isTotvs() && !isOmie()) || (lockFilledFields && !!nomeInicial && !isOmie())}
                        />

                        {loaded && (
                            <Input
                                label="E-mail"
                                name="email"
                                className="input"
                                id="email"
                                onChange={e => validateEmailChange(e)}
                                onBlur={() => emailIsValid(email)}
                                erro={erroEmail}
                                messageErro={erroEmailMsg}
                                value={email}
                                disabled={isTotvs() && !isOmie()}
                            />
                        )}

                        <Input
                            name="cpf_cnpj"
                            type="text"
                            value={cpf_cnpj}
                            label="CPF/CNPJ"
                            labelWithAsterisk={true}
                            id="cpf_cnpj_id"
                            onChange={e => validateCpf(e)}
                            onBlur={(e) => cpfIsValid(e.target.value)}
                            erro={erroCpf}
                            messageErro={erroCpfMsg}
                            inputmode="numeric"
                            disabled={(isTotvs() && !isOmie()) || (lockFilledFields && !!cpfInicial && !isOmie())}
                        />
                        <Input
                            name="telefone"
                            type="text"
                            value={telefone}
                            label="Telefone"
                            labelWithAsterisk={true}
                            id="telefone"
                            onChange={e => {
                                setTelefone(e);
                                if (erroTelefone) {
                                    setErroTelefone(false);
                                    setErroTelefoneMsg('');
                                }
                            }}
                            inputmode="numeric"
                            erro={erroTelefone}
                            messageErro={erroTelefoneMsg}
                            disabled={(isTotvs() && !isOmie()) || (lockFilledFields && !!telefoneInicial && !isOmie())}
                        />
                        <Input
                            name="celular"
                            value={celular}
                            type="text"
                            label="Celular (opcional)"
                            id="celular"
                            onChange={e => setCelular(e)}
                            inputmode="numeric"
                            disabled={isTotvs() && !isOmie()}
                        />
                        <Input
                            name="cep"
                            value={cep}
                            type="text"
                            label="CEP"
                            labelWithAsterisk={true}
                            id="cep"
                            onChange={e => {
                                setCep(e);
                                if (erroCep) {
                                    setErroCep(false);
                                    setErroCepMsg('');
                                }
                            }}
                            onBlur={e => fetchCep(e.target.value)}
                            inputmode="numeric"
                            erro={erroCep}
                            messageErro={erroCepMsg}
                            disabled={(isTotvs() && !isOmie()) || (lockFilledFields && !!cepInicial && !isOmie())}
                        />

                        <Input
                            name="logradouro"
                            value={logradouro}
                            type="text"
                            label="Logradouro"
                            labelWithAsterisk={true}
                            id="logradouro"
                            onChange={e => {
                                setLogradouro(e);
                                if (erroLogradouro) {
                                    setErroLogradouro(false);
                                    setErroLogradouroMsg('');
                                }
                            }}
                            erro={erroLogradouro}
                            messageErro={erroLogradouroMsg}
                            disabled={(isTotvs() && !isOmie()) || (lockFilledFields && !!logradouroInicial && !isOmie())}
                        />

                        <Input
                            name="bairro"
                            value={bairro}
                            type="text"
                            label="Bairro"
                            labelWithAsterisk={true}
                            id="bairro"
                            onChange={e => {
                                setBairro(e);
                                if (erroBairro) {
                                    setErroBairro(false);
                                    setErroBairroMsg('');
                                }
                            }}
                            erro={erroBairro}
                            messageErro={erroBairroMsg}
                            disabled={(isTotvs() && !isOmie()) || (lockFilledFields && !!bairroInicial && !isOmie())}
                        />

                        <Input
                            name="numero"
                            value={numero}
                            label="Número"
                            labelWithAsterisk={true}
                            id="numero"
                            onChange={e => {
                                setNumero(e);
                                if (erroNumero) {
                                    setErroNumero(false);
                                    setErroNumeroMsg('');
                                }
                            }}
                            erro={erroNumero}
                            messageErro={erroNumeroMsg}
                            disabled={(isTotvs() && !isOmie()) || (lockFilledFields && !!numeroInicial && !isOmie())}
                        />
                        <Input
                            name="complemento"
                            value={complemento}
                            type="text"
                            label="Complemento (opcional)"
                            id="complemento"
                            onChange={e => setComplemento(e)}
                            disabled={isTotvs() && !isOmie()}
                        />
                        <Input
                            name="cidade"
                            value={cidade}
                            type="text"
                            label="Cidade"
                            labelWithAsterisk={true}
                            id="cidade"
                            onChange={e => {
                                setCidade(e);
                                if (erroCidade) {
                                    setErroCidade(false);
                                    setErroCidadeMsg('');
                                }
                            }}
                            erro={erroCidade}
                            messageErro={erroCidadeMsg}
                            disabled={(isTotvs() && !isOmie()) || (lockFilledFields && !!cidadeInicial && !isOmie())}
                        />

                        <Select
                            name="estado"
                            value={estado}
                            label="Estado"
                            className="select"
                            labelWithAsterisk={true}
                            estado={true}
                            id="estado"
                            defaultInputValue={estado}
                            onChange={estado => {
                                setEstado(estado.value);
                                if (erroEstado) {
                                    setErroEstado(false);
                                    setErroEstadoMsg('');
                                }
                            }}
                            options={estados}
                            erro={erroEstado}
                            messageErro={erroEstadoMsg}
                            onBlur={(e) => limpaCep(e.target.value)}
                            disabled={(isTotvs() && !isOmie()) || (estado.value || estado ? true : false)}
                        />

                        <Select
                            name="status"
                            value={status}
                            label="Status"
                            className="select"
                            id="status"
                            onChange={status => setStatus(status.value)}
                            options={[
                                { label: 'Ativo', value: 1 },
                                { label: 'Inativo', value: 0 }
                            ]}
                            // Omie só permite inativar cliente pela própria tela (API não aceita,
                            // confirmado ao vivo) - inativar só localmente deixaria o dado
                            // divergente do que a Omie mostra, então trava aqui igual Totvs/Protheus.
                            disabled={isTotvs()}
                        />

                        <div
                            className="button-finish"
                            style={{
                                width: '100%',
                                display: 'flex',
                                flexDirection: 'row',
                                justifyContent: 'space-between',
                                alignItems: 'center',
                                marginTop: '40px',
                            }}
                        >
                            <Button
                                width='45%'
                                height='50px'
                                value='VOLTAR'
                                outline={true}
                                disabled={false}
                                onClick={() => goBack()}
                                loading={false}
                            />

                            <Button
                                width='45%'
                                height='50px'
                                value='SALVAR'
                                outline={false}
                                disabled={isTotvs() && !isOmie()}
                                onClick={() => editPost()}
                                loading={loading}
                            />

                        </div>

                        <div
                            className="button-finish"
                            style={{
                                width: '100%',
                                display: 'flex',
                                flexDirection: 'row',
                                justifyContent: 'center',
                                alignItems: 'center',
                                marginTop: '40px',
                                marginBottom: '40px',
                            }}
                        >
                            <Button
                                width='100%'
                                height='50px'
                                value='ADICIONAR UM LOCAL DE APLICAÇÃO'
                                outline={false}
                                disabled={isTotvs() && !isOmie()}
                                onClick={() => addLocal()}
                                loading={false}
                            />


                        </div>

                        <ModalYesNo
                            show={showModalYesNo}
                            onHide={() => modalClose()}
                            resposta=''
                            update={(e) => updateRespostaYesNo(e)}
                            title='Atenção!'
                            text={msg}
                            btnNo={true}
                        ></ModalYesNo>

                        <ModalText
                            show={showModalText}
                            onHide={() => closeOk()}
                            text={msg2}
                            btnOk={true}
                            btnCancelar={false}
                            update={() => updateOk()}
                        ></ModalText>

                        <Modal
                            show={showModalGeneric}
                            onHide={() => {
                                setShowModalGeneric(false);
                                setModalGeneric(false);
                            }}
                        >
                            {modalGeneric}
                        </Modal>

                    </form>

                    {size_screen <= 768 ? (<>
                        <CardGeral
                            titulos={["FAZENDAS_PRODUTOR", "NOME DA FAZENDA", "CULTURAS", "ESTADO", "CNPJ"]}
                            valores={produtorInativo ? locais.map(l => ({ ...l, status: 0 })) : locais}
                        />
                    </>) : (<>
                        <Table>
                            <thead>
                                <tr>
                                    <th>Nome da Fazenda</th>
                                    <th>Cultura</th>
                                    <th>Estado</th>
                                    <th>CNPJ</th>
                                </tr>
                            </thead>
                            <TBody>
                                {locais.map(local => (

                                    <tr
                                        onClick={e =>
                                            props.history.push(`/fazendas/edit/${local.id}/${id}`)
                                        }
                                        key={local.id}
                                    >
                                        {(local.status == 1 && !produtorInativo) ? (
                                            <td>{local.nome}</td>
                                        ) : (
                                            <td>
                                                <strike>{local.nome}</strike>
                                            </td>
                                        )}

                                        {(local.status == 1 && !produtorInativo) ? (
                                            <td>
                                                {local.cultura != null && local.cultura != "" && typeof (local.cultura) != 'string' ? (
                                                    local.cultura.map(cultura => {
                                                        return <div style={{ marginLeft: '2px' }}>{cultura.nome_comum}</div>
                                                    })
                                                ) : (
                                                    <div style={{ marginLeft: '2px' }}>-</div>
                                                )}
                                            </td>

                                        ) : (

                                            <td>
                                                {local.cultura != null && local.cultura != "" && typeof (local.cultura) != 'string' ? (
                                                    local.cultura.map(cultura => {
                                                        return <div style={{ marginLeft: '2px' }}><strike>{cultura.nome_comum}</strike></div>
                                                    })
                                                ) : (
                                                    <div style={{ marginLeft: '2px' }}>-</div>
                                                )}
                                            </td>

                                        )}

                                        {(local.status == 1 && !produtorInativo) ? (
                                            <td>
                                                <div className="estado">{local.estado}</div>
                                            </td>
                                        ) : (
                                            <td>
                                                <div className="estado-inativo"> {local.estado} </div>
                                            </td>
                                        )}


                                        {(local.status == 1 && !produtorInativo) ? (
                                            <td>{local.cpf_cnpj}</td>
                                        ) : (
                                            <td>
                                                <strike>{local.cpf_cnpj}</strike>
                                            </td>
                                        )}
                                    </tr>
                                ))}
                            </TBody>
                        </Table>
                    </>)}

                </Container>
            </ProdutoresAddContainer>
        </>
    )


}
export default withRouter(EditProdutores);
